export default __webpack_public_path__ + "static/media/division-4.07d89965.png";